var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKibleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0845 11H16.5129L13.9853 16.4398H18.3718H18.4088L20.8867 11H25.2878L22.7729 16.4398H18.4088H18.3718L20.9507 21.825H16.5129L13.9853 16.4398L11.4831 21.825H7L12.0845 11Z",
    fill: "#B32222"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.0422,
    y: 19.3417,
    width: 2.48341,
    height: 2.48341,
    rx: 0.820204,
    fill: "#B32222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKibleLogo);
export default __webpack_public_path__ + "static/media/kibleLogo.b1068c2ec3735ba5f8a01587442f4d77.svg";
export { ForwardRef as ReactComponent };